import { useState } from "react";
import { Box } from "@kaltura/mediaspace-shared-styled";
import { styled } from "@mui/material";
import { Genie, GenieProps } from "./Genie";

export type TemplatePageComponentProps = Omit<GenieProps, "onExpand" | "onClose" | "isExpanded">;

const StyledWrapper = styled(
    Box,
    { shouldForwardProp: (prop) => prop !== "isExpanded" }
)<{ isExpanded: boolean }>(({ theme, isExpanded }) =>
    isExpanded
        ? {
              position: "fixed",
              inset: 0,
              zIndex: theme.zIndex.modal - 1,
              backgroundColor: theme.palette.background.paper,
              display: "flex",
              flexDirection: "column",
          }
        : {
              position: "static",
          }
);

const StyledContent = styled(Box)({
    flex: 1,
    overflow: "hidden",
});

/**
 * Genie wrapper for template pages.
 * Owns the expand/collapse state so the template page host doesn't need to.
 */
export const TemplatePageComponent = (props: TemplatePageComponentProps) => {
    const [isExpanded, setIsExpanded] = useState(false);

    return (
        <StyledWrapper isExpanded={isExpanded}>
            <StyledContent>
                <Genie
                    {...props}
                    isFullSize={true}
                    onExpand={() => setIsExpanded((prev) => !prev)}
                    onClose={() => setIsExpanded(false)}
                    isExpanded={isExpanded}
                />
            </StyledContent>
        </StyledWrapper>
    );
};
